import React from 'react';
import ReactDOM from 'react-dom/client';

// Mantine: design system (styles vóór eigen CSS zodat onze overrides winnen)
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import theme from './theme';

import './index.css';
import App from './App';

// Note: React 18 UMD builds are loaded in index.html for StreetSmart API compatibility
// This provides window.React and window.ReactDOM globally

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <ModalsProvider>
        <Notifications position="top-right" />
        <App />
      </ModalsProvider>
    </MantineProvider>
  </React.StrictMode>
);
